import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../components/router/router-tabbed-navigation';
import { OrderBlotterTable } from '../../../../../../../../features/trade-reporting/order-blotter/order-blotter-table';
import { getPageHead } from '../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/order-blotter')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsReporting,
      label: 'Order Blotter',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsReporting>,
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'order-blotter',
        label: 'Reports',
        to: '/clearing/operations/reporting/order-blotter',
      }),
    }) satisfies AggregateBreadcrumb,
  head: () => getPageHead('Order Blotter'),
  component: OrderBlotter,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsReporting}
    />
  );
}

function OrderBlotter() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <OrderBlotterTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
